import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  BoardingPassDataRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  createBaggage,
  createMockData,
  createMockDataWithResponse,
  MockBoardingPassResult,
  MockJourney,
} from '@dapi/sdk/spec';
import {
  addedBaggageTemplate,
  baggageToPay,
  defaultTwoCheckInBaggagePolicies,
  noItemToPayError,
  paymentRecords,
} from '../../../mock/data';
import {
  authorization,
  contactEmail,
  contactPhone,
} from '../../../mock/dictionaries';
import {
  retrieveSeatMapsJourneyDriven,
} from '../common/seatmap';
import {
  serviceCatalog,
} from '../common/services';
import {
  acceptedChosenJourney,
  journeyElementIds,
  journeys,
  validRegulatoryJourney,
  validRegulatoryJourneyFirstPax,
} from './journey-logic';
import {
  addRegulatoryDetailsFirstPax,
  addRegulatoryDetailsSecondPax,
  getRegulatoryDetailsFirstPax,
  getRegulatoryDetailsFirstPaxCompleted,
  getRegulatoryDetailsSecondPax,
  getRegulatoryDetailsSecondPaxCompleted,
} from './regulatory-logic';

const bp: MockBoardingPassResult[] = combineBoardingPassResults([{
  boardingPassData: BoardingPassDataRepository.TSA
}], {
  journeyElementIds
}).items;

const retrieveJourney: MockJourney[] = [
  validRegulatoryJourneyFirstPax,
  validRegulatoryJourney,
  acceptedChosenJourney
];

const seatmap = retrieveSeatMapsJourneyDriven(journeys[0], journeys[0].travelers.map((t) => t.id).filter((id): id is string => !!id));
const CONTACTS = [contactPhone, {
  ...contactEmail,
  travelerIds: [journeys[0].travelers[0].id],
  address: 'tester@amadeus.com'
}];

/**
 * Test Spinner in all pages
 * 1 Journey - 2 flights -2 ADTs
 * Missing Regulatory Details
 * Add Baggage
 * Pay
 * Update Contacts
 */
export const ow1Journey2AdtMissingRegAddBagPayContacts: MockMap = {
  addJourneyBags: [createMockData([
    createBaggage({
      template: addedBaggageTemplate,
      id: 0
    }),
    createBaggage({
      template: addedBaggageTemplate,
      id: 1
    }),
    createBaggage({
      template: addedBaggageTemplate,
      id: 2
    })
  ])],
  authorizeJourneyPaymentRecord: [createMockData(authorization)],
  confirmJourneyPaymentRecord: [createMockData(paymentRecords)],
  createJourneyPaymentRecord: [createMockData(paymentRecords)],
  addRegulatoryDetails: [
    ...[...addRegulatoryDetailsFirstPax].map((reg) => createMockData({
      ...reg,
      travelerId: 'JOURNEY-TRAVELER-0-MOCK'
    })),
    ...[...addRegulatoryDetailsSecondPax].map((reg) => createMockData({
      ...reg,
      travelerId: 'JOURNEY-TRAVELER-1-MOCK'
    }))
  ],
  generateBoardingPasses: [createMockDataWithResponse(bp, 201)],
  getBaggagePoliciesFromJourney: [
    createMockData(combineCheckInBaggagePolicies(defaultTwoCheckInBaggagePolicies).items)
  ],
  getJourneyUnpaidItems: [
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError]),
    createMockData(baggageToPay),
    createMockData(baggageToPay),
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError])
  ],
  getRegulatoryDetails: [
    createMockData({
      ...getRegulatoryDetailsFirstPax,
      travelerId: 'JOURNEY-TRAVELER-0-MOCK'
    }),
    createMockData({
      ...getRegulatoryDetailsSecondPax,
      travelerId: 'JOURNEY-TRAVELER-1-MOCK'
    }),
    createMockData({
      ...getRegulatoryDetailsFirstPaxCompleted,
      travelerId: 'JOURNEY-TRAVELER-0-MOCK'
    }),
    createMockData({
      ...getRegulatoryDetailsSecondPaxCompleted,
      travelerId: 'JOURNEY-TRAVELER-1-MOCK'
    })
  ],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourney: retrieveJourney.map((j) => createMockData(j)),
  retrieveJourneyBaggages: [createMockData([])],
  servicesCatalogueFromJourney: [createMockData(serviceCatalog)],
  retrieveJourneys: [createMockDataWithResponse(journeys, 201)],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)],
  addContactsToJourney: [createMockData(CONTACTS)]
};
